import styles from "./style.module.css"
import cbn from "../../assets/icons/cbn.svg"
import footerAltBankLogo from "../../assets/icons/footeraltbanklogo.svg"
export default function CbnFooter() {
    return (
        <div className={styles.footer}>
            <p>Licensed by Central Bank of Nigeria <img src={cbn} alt="cbn-icon" /> | Powered by <img src={footerAltBankLogo} alt="footer-alt-bank-logo" /></p>
        </div>
    )
}